/**
 * Переводы для всех поддерживаемых языков
 */
export const TRANSLATIONS = {
    EN: {
        // Navigation
        home: 'Home',
        studio: 'Studio',
        gallery: 'Gallery',
        socials: 'Socials',
        trailer: 'Trailers',
        joinDiscord: 'Join Discord',
        followTelegram: 'Follow on Telegram',

        // Header Content
        headerContentTitle: 'We make games',
        headerContentDescription: 'We are a passionate team of Uzbek developers and artists creating an epic hero-based tower defense game - packed with stunning visuals, deep progression, and global appeal.',

        heroEyebrow: 'Tower defense by StranGen Group',

        // Hero Section
        heroTitle: 'Hero Arena',
        heroDescription: 'A strategy game where heroes lead the defense. Recruit, upgrade, and command your champions to fight back. The fate of the castle is in your hands.',

        // Roster
        rosterTitle: 'Build your roster',
        rosterStatus: '4 of 32 heroes recruited — more are joining the ranks.',
        rosterHero1Name: 'Swordsman',
        rosterHero1Role: 'Tank',
        rosterHero1Description: 'A humble melee warrior with a rusty sword, driven by courage and persistence to prove true heroism.',
        rosterHero2Name: 'Archer',
        rosterHero2Role: 'Ranged',
        rosterHero2Description: 'Strikes enemies from range before they reach the line.',
        rosterHero3Name: 'Healer',
        rosterHero3Role: 'Support',
        rosterHero3Description: 'Keeps the team alive through the fight.',
        rosterHero4Name: 'Mage',
        rosterHero4Role: 'Magic Damage',
        rosterHero4Description: 'Burns down enemies with magic damage.',
        rosterLockedLabel: 'More heroes in development',

        // Gallery
        galleryTitle: 'Screenshots',

        // Gallery captions
        galleryCaption1: 'Rank up, upgrade, and build your team of four.',
        galleryCaption2: 'Abilities turn a losing lane around.',
        galleryCaption3: 'Four heroes, one screen, no pausing to think.',
        galleryCaption4: 'Your tower anchors the lane. Heroes hold the flanks.',
        galleryCaption5: 'Later waves send cavalry. Faster, and it hits harder.',

        // Section
        sectionTitle: 'Join the Hero Arena community',
        sectionDescription: 'Get development updates, new hero reveals, and playtest news directly from StranGen Group.',

        // Video
        videoSectionTitle: 'Watch it in action',
        videoTitle1: 'Game Pitch for President Tech Award',
        videoTitle2: 'Official Game Trailer',
        playVideo: 'Play',

        // Footer
        footerCopyright: '© StranGen Group',
        backToTop: 'Back to top',
        watchOnYoutube: 'Watch on YouTube',
    },

    RU: {
        // Навигация
        home: 'Главная',
        studio: 'Студия',
        gallery: 'Галерея',
        socials: 'Соцсети',
        trailer: 'Трейлеры',
        joinDiscord: 'Вступить в Discord',
        followTelegram: 'Мы в Telegram',

        // Заголовок
        headerContentTitle: 'Мы создаём игры',
        headerContentDescription: 'Мы команда узбекских разработчиков и художников, создающих эпичную игру в жанре tower defense с героями - с потрясающей графикой, глубокой прогрессией и мировым потенциалом.',

        // Эйбраузы волн: в самой игре HUD всегда пишет "Wave: 1" латиницей,
        // поэтому эти ярлыки не переводятся, как и имена героев.
        heroEyebrow: 'Tower defense от StranGen Group',

        // Герои
        heroTitle: 'Hero Arena',
        heroDescription: 'Стратегическая игра, где герои возглавляют оборону. Нанимай, улучшай и командуй своими чемпионами. Судьба замка в твоих руках.',

        // Ростер
        rosterTitle: 'Собери свой отряд',
        rosterStatus: '4 из 32 героев уже в строю — отряд продолжает расти.',
        rosterHero1Name: 'Swordsman',
        rosterHero1Role: 'Танк',
        rosterHero1Description: 'Простой воин с ржавым мечом ближнего боя, которого ведут вперёд отвага и упорство — доказать, что он настоящий герой.',
        rosterHero2Name: 'Archer',
        rosterHero2Role: 'Дальний бой',
        rosterHero2Description: 'Бьёт по врагам издалека, не подпуская их к линии.',
        rosterHero3Name: 'Healer',
        rosterHero3Role: 'Поддержка',
        rosterHero3Description: 'Удерживает отряд в живых на протяжении всего боя.',
        rosterHero4Name: 'Mage',
        rosterHero4Role: 'Магический урон',
        rosterHero4Description: 'Сжигает врагов магическим уроном.',
        rosterLockedLabel: 'Ещё герои в разработке',

        // Галерея
        galleryTitle: 'Скриншоты',

        // Подписи галереи
        galleryCaption1: 'Повышай ранг, улучшай героев и собирай отряд из четырёх.',
        galleryCaption2: 'Способности переламывают ход боя.',
        galleryCaption3: 'Четыре героя на одном экране — думать некогда.',
        galleryCaption4: 'Башня держит центр, герои — фланги.',
        galleryCaption5: 'Поздние волны присылают кавалерию — быстрее и сильнее.',

        // Раздел
        sectionTitle: 'Присоединяйся к сообществу Hero Arena',
        sectionDescription: 'Получай новости разработки, новых героев и анонсы плейтестов прямо от StranGen Group.',

        // Видео
        videoSectionTitle: 'Смотри в деле',
        videoTitle1: 'Презентация игры для President Tech Award',
        videoTitle2: 'Официальный трейлер игры',
        playVideo: 'Смотреть',

        // Футер
        footerCopyright: '© StranGen Group',
        backToTop: 'Наверх',
        watchOnYoutube: 'Смотреть на YouTube',
    },

    UZ: {
        // Navigatsiya
        home: 'Bosh sahifa',
        studio: 'Studiya',
        gallery: 'Galereya',
        socials: 'Ijtimoiy tarmoqlar',
        trailer: 'Trelerlar',
        joinDiscord: 'Discord’ga qo‘shiling',
        followTelegram: 'Telegram’da kuzating',

        // Sarlavha
        headerContentTitle: 'Biz o‘yinlar yaratamiz',
        headerContentDescription: 'Biz — o‘z ishiga mehr qo‘ygan o‘zbekistonlik dasturchilar va rassomlar jamoasimiz. Biz qahramonlarga asoslangan epik tower defense o‘yinini yaratyapmiz — ajoyib grafika, chuqur rivojlanish tizimi va global auditoriya uchun.',

        // Wave yorliqlari: o'yinning o'zida HUD har doim lotin yozuvida
        // "Wave: 1" deb ko'rsatadi, shuning uchun bu yorliqlar tarjima
        // qilinmaydi, xuddi qahramon ismlari kabi.
        heroEyebrow: 'StranGen Group’dan tower defense',

        // Qahramonlar bo‘limi
        heroTitle: 'Hero Arena',
        heroDescription: 'Bu strategiya o‘yini, unda qahramonlar qal’ani himoya qiladi. Qahramonlaringni yollang, kuchaytiring va boshqaring. Qal’aning taqdiri sizning qo‘lingizda.',

        // Roster
        rosterTitle: 'Jamoangizni tuzing',
        rosterStatus: '32 tadan 4 qahramon jamoada — safimiz kengaymoqda.',
        rosterHero1Name: 'Swordsman',
        rosterHero1Role: 'Tank',
        rosterHero1Description: 'Zang bosgan qilichi bilan jang qiluvchi oddiy jangchi — jasorat va matonat bilan haqiqiy qahramon ekanini isbotlamoqda.',
        rosterHero2Name: 'Archer',
        rosterHero2Role: 'Uzoq masofa',
        rosterHero2Description: 'Dushmanlarni safga yetib kelishidan oldin uzoqdan uradi.',
        rosterHero3Name: 'Healer',
        rosterHero3Role: 'Yordamchi',
        rosterHero3Description: 'Jang davomida jamoani tirik saqlaydi.',
        rosterHero4Name: 'Mage',
        rosterHero4Role: 'Sehrli zarar',
        rosterHero4Description: 'Dushmanlarni sehrli zarar bilan kuydiradi.',
        rosterLockedLabel: 'Yana qahramonlar ishlab chiqilmoqda',

        // Galereya
        galleryTitle: 'Skrinshotlar',

        // Galereya sarlavhalari
        galleryCaption1: 'Darajani oshiring, qahramonlarni kuchaytiring va to\'rt kishilik jamoa tuzing.',
        galleryCaption2: 'Qobiliyatlar jang yo\'nalishini o\'zgartiradi.',
        galleryCaption3: 'To\'rt qahramon, bitta ekran — o\'ylashga vaqt yo\'q.',
        galleryCaption4: 'Minora markazni, qahramonlar qanotlarni ushlab turadi.',
        galleryCaption5: 'Keyingi to\'lqinlarda otliqlar keladi — tezroq va kuchliroq.',

        // Bo‘lim
        sectionTitle: 'Hero Arena hamjamiyatiga qo‘shiling',
        sectionDescription: 'StranGen Group’dan ishlab chiqish yangiliklari, yangi qahramonlar va pleystest e’lonlarini oling.',

        // Video
        videoSectionTitle: 'Harakatda tomosha qiling',
        videoTitle1: 'President Tech Award uchun o‘yin taqdimoti',
        videoTitle2: 'Rasmiy o‘yin treyleri',
        playVideo: "Ko'rish",

        // Footer
        footerCopyright: '© StranGen Group',
        backToTop: 'Yuqoriga',
        watchOnYoutube: 'YouTube’da ko‘rish',
    },
};

export const LANGUAGES = [
    { code: 'EN', name: 'English' },
    { code: 'RU', name: 'Русский' },
    { code: 'UZ', name: "O'zbekcha" },
];

export const DEFAULT_LANGUAGE = 'EN';
